import axios from 'axios';
export const analyticsApi = axios.create({
  baseURL: process.env.REACT_APP_ANALYTICS_API_URL,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});
export const vnayaAnalyticsApi = axios.create({
  baseURL: process.env.REACT_APP_VNAYA_API_URL_ANALYTICS,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});
export const vnayaApi = axios.create({
  baseURL: process.env.REACT_APP_VNAYA_API_URL,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});
export const localapi = axios.create({
  baseURL: 'http://localhost:3000/api/ai',
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
});
export default api;
